export default __webpack_public_path__ + "static/media/Prayer time in Mysore.ccf9feef.jpg";